var exports = {
  "k": "x2b2fbebb--8bff5f--container",
};

module.exports = exports;
